<div class="date-picker-geo-rules">
  <form [formGroup]="formGroup">
    <div class="column">
      <div style="width: fit-content">
        <pdq-radio-group
          formControlName="geoFenceMethod"
          (onChange)="onGeoFenceMethodChange($event)"
          label="Select geo-fencing method"
          labelSize="small"
          color="var(--on-surface-default)">
          @for (geoMethod of geoFenceMethodsConfig; track geoMethod) {
            <pdq-radio-button
              [value]="geoMethod.value"
              [checked]="geoMethod.checked(formGroup.value['geoFenceMethod']) || geoMethod.defaultChecked"
              [text]="geoMethod.text">
            </pdq-radio-button>
          }
        </pdq-radio-group>
      </div>

      @if (formGroup.controls['geoFenceMethod']?.errors?.missingGeoRules) {
        <div class="error">
          {{ formGroup.controls['geoFenceMethod']?.errors?.missingGeoRules }}
        </div>
      }

      <div>
        <pdq-dropdown
          [fullWidth]="true"
          title="Delivery service inventory location"
          formControlName="deliveryServiceInventoryLocationId"
          placeholder="Select inventory"
          [options]="shop?.shopLocations | shopLocationOptions"
          [defaultOption]="shop?.shopLocations | shopLocationOptions: true"
          [invalid]="formGroup.controls.deliveryServiceInventoryLocationId.errors?.required"
          [invalidMsg]="
            formGroup.controls.deliveryServiceInventoryLocationId.errors?.required
              ? 'Inventory location is required'
              : ''
          "></pdq-dropdown>
      </div>
      @if (formGroup.value['geoFenceMethod'] === formArrayFieldName) {
        <div>
          <div style="font-size: 14px">Geo-rules</div>
          <pdq-rules-dynamic-form
            [formGroup]="formGroup"
            [formArrayFieldName]="formArrayFieldName"
            [rules]="geoRules"
            [entities]="entities"
            [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
        </div>
      }
    </div>
  </form>
</div>
